<h1>
  Choose your trip
  <span *ngIf="groups.length > 1">
    for each day
  </span>
</h1>

<div *ngFor="let group of groups">
  <h3>{{ group.dateKey | date:'dd/MM/yyyy' }}</h3>
    <div class="list-group list-group-horizontal-sm flex-wrap-sm mb-4">
      <a class="list-group-item list-group-item-action"
        *ngFor="let trip of group.trips"
        (click)="group.selected = trip;"
        [class.active]="group.selected.id === trip.id"
      >
        <fa-icon [icon]="faCheck" *ngIf="group.selected.id === trip.id"></fa-icon>
<!--        {{ trip.date | date: 'HH:mm' }}-->
<h3>{{ route?.name }} <span *ngIf="group.selected?.name">- {{ group.selected.name }}</span></h3>

        <span class="badge badge-secondary" *ngIf="trip.name">{{ trip.name }}</span>
      </a>
    </div>
</div>

<button class="btn btn-success btn-block btn-lg"
        (click)="ok()">
  Continue
</button>

